import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import axios from "axios";
import performance from "../../../../../assets/performance.png";
import appUrl from "../../../../config/appUrl";

const ENTRY = "#4475a5";
const ENTRY_FILL = "rgba(68, 117, 165, 0.12)";
const EXIT = "#10b981";
const EXIT_FILL = "rgba(16, 185, 129, 0.12)";

const SiteStatsChart = () => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [chartData, setChartData] = useState(null);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${appUrl.BASE_URL}ParkingHistory/getParkingCollectionSummary`,
        {
          params: {
            isMonthly: isMonthly,
            GTagDataOnly: false,
            QRDataOnly: false,
          },
        },
      );

      const apiData = res.data.data || [];

      let labels = [];
      let entryValues = [];
      let exitValues = [];

      if (isMonthly) {
        const monthNames = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ];

        const uniqueMonths = [...new Set(apiData.map((d) => d.month))].sort((a, b) => a - b);

        labels = uniqueMonths.map((m) => monthNames[m - 1]);

        entryValues = uniqueMonths.map((m) =>
          apiData
            .filter((d) => d.month === m && d.feeType === "Entry")
            .reduce((sum, d) => sum + d.totFee, 0)
        );

        exitValues = uniqueMonths.map((m) =>
          apiData
            .filter((d) => d.month === m && d.feeType === "Exit")
            .reduce((sum, d) => sum + d.totFee, 0)
        );
      } else {
        labels = [...new Set(apiData.map((d) => ` ${d.day}`))];

        entryValues = labels.map((day) =>
          apiData
            .filter((d) => ` ${d.day}` === day && d.feeType === "Entry")
            .reduce((sum, d) => sum + d.totFee, 0)
        );

        exitValues = labels.map((day) =>
          apiData
            .filter((d) => ` ${d.day}` === day && d.feeType === "Exit")
            .reduce((sum, d) => sum + d.totFee, 0)
        );
      }

      setChartData({
        labels: labels,
        datasets: [
          {
            label: "Entry Fee",
            data: entryValues,
            borderColor: ENTRY,
            backgroundColor: ENTRY_FILL,
            tension: 0.35,
            fill: true,
          },
          {
            label: "Exit Fee",
            data: exitValues,
            borderColor: EXIT,
            backgroundColor: EXIT_FILL,
            tension: 0.35,
            fill: true,
          },
        ],
      });
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [isMonthly]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: function (context) {
            const val = context.parsed.y;
            return val ? Math.round(val).toLocaleString() : "0";
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return Math.round(value).toLocaleString();
          },
        },
        grid: { color: "#eef2f6" },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    <div className="dashboard-chart-inner">
      <div className="dashboard-chart-head">
        <h5>Parking Collection</h5>
        <select
          className="dashboard-chart-select"
          value={isMonthly ? "monthly" : "daily"}
          onChange={(e) => setIsMonthly(e.target.value === "monthly")}
          aria-label="Report period"
        >
          <option value="monthly">Yearly</option>
          <option value="daily">Last Month</option>
        </select>
      </div>
      <div className="dashboard-chart-canvas">
        {chartData ? (
          <Chart type="line" style={{ height: "300px" }} data={chartData} options={options} />
        ) : (
          <p className="text-600 m-0">Loading…</p>
        )}
      </div>
    </div>
  );
};

export default SiteStatsChart;
